import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const Route = createFileRoute('/_private-routes/campaign-posts-discovery')({
  staticData: {
    menuTitle: MenuTitle.CampaignPosts
  }
});
